import React, { createContext, FunctionComponent, useContext, useEffect, useState } from "react";

const TrackingParameterContext = createContext<{ campaign?: string; medium?: string }>({});

export const TrackingParameterProvider: FunctionComponent = ({ children }) => {
    const [trackingParameters, setTrackingParameters] = useState<{ campaign: string; medium: string }>({
        campaign: "",
        medium: "",
    });

    function extractHashParameters() {
        const hash = window.location.hash;
        const paramsString = hash.includes("?") ? hash.split("?")[1] : "";
        return new URLSearchParams(paramsString);
    }

    function extractSearchParameters() {
        const search = window.location.search;
        const paramsString = search.includes("?") ? search.split("?")[1] : "";
        return new URLSearchParams(paramsString);
    }

    useEffect(() => {
        (async function readTrackingParameters() {
            const hashParams = extractHashParameters();
            const searchParams = extractSearchParameters();

            setTrackingParameters({
                campaign: hashParams.get("etcc_cmp") ?? searchParams.get("etcc_cmp") ?? "",
                medium: hashParams.get("etcc_med") ?? searchParams.get("etcc_med") ?? "",
            });
            console.log("tracking parameters", trackingParameters.campaign);
        })();
    }, []);

    return <TrackingParameterContext.Provider value={trackingParameters}>{children}</TrackingParameterContext.Provider>;
};

export const useTrackingParameters = () => {
    return useContext(TrackingParameterContext);
};
